import { GLOBAL_ERROR, APPROVAL_NOT_FOUND } from '@/utils/constants';
import Vue from 'vue';
import {
  getHRApprovals as getHRApprovalsApi,
  getHRApproval as getHRApprovalApi,
  approvalDecision as approvalDecisionApi,
  openContractAgreement as openContractAgreementApi,
  updateApproval as updateApprovalApi
} from '../../api/approvals';
import { default as getFileApi } from '../../api/files/get-file';
import { getQuotePDF as getQuotePDFApi } from '../../api/quotes';

export function getHRApprovals({ commit }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['approvalsLoading', true]);
      commit('setApprovals', await getHRApprovalsApi());
      commit('setState', ['approvalsLoading', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['approvalsLoading', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getHRApprovals')
      });
      return reject();
    }
  });
}

export async function getHRApproval({ commit }, { id }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['approvalLoading', true]);
      const { approval, application } = await getHRApprovalApi({ uuid: id });

      if (!approval) {
        commit('setState', ['approvalLoading', false]);
        return reject(APPROVAL_NOT_FOUND);
      }

      commit('setApproval', approval);
      commit('snapshotApproval');
      commit('setHrApplicationApproval', application);
      commit('setState', ['approvalLoading', false]);

      return resolve();
    } catch (err) {
      commit('setState', ['approvalLoading', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getHRApproval')
      });
      return reject();
    }
  });
}

export function approvalDecision({ commit, state, dispatch }, hrApproval) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['approvalSaving', true]);
      const approval = await approvalDecisionApi(
        state.approval.approvalId || state.approval.applicationId,
        {
          approvalStatus: hrApproval,
          approvalNotes: state.approval.approvalNotes,
          approvalReason: state.approval.approvalReason
        }
      );
      commit('setApproval', approval);
      commit('snapshotApproval');
      // Fetch a new list of approvals to update the pending approval alert
      await dispatch('getHRApprovals');
      commit('setState', ['approvalSaving', false]);
      commit('setHrApprovalDenyOpen', false);
      return resolve();
    } catch (err) {
      commit('setState', ['approvalSaving', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('denyApplication')
      });
      return reject();
    }
  });
}

export async function getQuotePDF({ commit, dispatch, state }, quoteId) {
  return new Promise(async (resolve, reject) => {
    if (!quoteId) {
      return reject(new Error('No quote exists'));
    }
    try {
      commit('setState', ['loadingQuotePDF', true]);
      const quotePDF = await getQuotePDFApi(quoteId);

      commit('setQuotePDFHref', quotePDF.signedUrl);
      commit('setState', ['loadingQuotePDF', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['loadingQuotePDF', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getQuotePDF')
      });
      return reject();
    }
  });
}

export async function openContractAgreement({ commit, dispatch, state }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['openingContractAgreement', true]);
      const { url } = await openContractAgreementApi({
        applicationId: state.approval.applicationId
      });
      commit('setState', ['openingContractAgreement', false]);
      return resolve(url);
    } catch (err) {
      commit('setState', ['openingContractAgreement', false]);
      // eslint-disable-next-line
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('denyApplication')
      });
      return reject();
    }
  });
}

export async function openContract({ commit, state }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['loadingContractPdf', true]);
      const { signedUrl } = await getFileApi(state.application.metaData.fileId);
      commit('setState', ['loadingContractPdf', false]);
      return resolve(signedUrl);
    } catch (err) {
      commit('setState', ['loadingContractPdf', false]);
      return reject();
    }
  });
}

export async function updateApproval({ commit, state }) {
  try {
    commit('setState', ['approvalUpdating', true]);
    const { payrollNumber, costCenter, approvalId, applicationId } =
      state.approval;
    const uuid = approvalId || applicationId;
    const payLoad = { payrollNumber, costCenter };
    const updatedApproval = await updateApprovalApi(uuid, payLoad);
    commit('setApproval', updatedApproval);
    commit('snapshotApproval');
    commit('setState', ['approvalUpdating', false]);
  } catch (err) {
    commit('setState', ['approvalUpdating', false]);
  }
}
